export default __webpack_public_path__ + "static/media/arrorTop.d68b45f9.svg";